import React, { useEffect, useRef, useState } from "react";
import { Box, Container, Fade, useMediaQuery } from "@mui/material";
import logoImg from "../../../residenzaStoricaAssets/1811white.png";
import backgroundImg from "../../../assets/resFinal/dipinto.webp";

function CustomLanding() {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isLandscape = useMediaQuery("(orientation: landscape)");
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false); // State to track visibility
  const images = [backgroundImg]; // Add more images here if needed

  const sectionRef = useRef(null); // Ref for the observed section

  // Background image carousel
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 4500);
    return () => clearInterval(interval);
  }, [images.length]);

  // Intersection Observer
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting); // Update visibility
      },
      { threshold: 0.5 } // Trigger when at least 50% of the section is visible
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <Box
      ref={sectionRef} // Attach ref to the section to be observed
      sx={{
        zIndex: 4,
        backgroundImage: `
        url(${images[currentImageIndex]})`,
        transition: "background-image 1s ease-in-out",
        backgroundSize: "cover",
        backgroundColor: "#485e6c",
        backgroundPosition: "center 32%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        paddingTop:
          isMobile && !isLandscape
            ? "15%"
            : isLandscape && isMobile
            ? "5%"
            : undefined,
      }}
    >
      <Container
        sx={{
          height: "100vh",
          display: "flex",
          zIndex: 1000,
          flexDirection: "column",
          alignItems: "center",
          justifyContent: isLandscape ? "center" : "center",
        }}
      >
        <Box
          style={{
            width: "90%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "center",
            paddingBottom: isLandscape ? "2vw" : "80px",
          }}
        >
          <Fade in={isVisible} timeout={2000}>
            <h1
              style={{
                color: "white",
                textAlign: "center",
              }}
            >
              <img
                alt="1811 Residenza Storica"
                src={logoImg}
                width={isLandscape ? "40%" : isMobile ? "95%" : "55%"}
              />
            </h1>
          </Fade>
        </Box>{" "}
        <Box
          style={{
            width: "90%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        ></Box>{" "}
      </Container>
    </Box>
  );
}

export default CustomLanding;
